import React from "react"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import {Col, Row} from "react-bootstrap";


export default function GratitudeViewSkeleton() {
    return(
        <div className={'gratitude'}>
            <h2> <HeadingSkeleton block={false} height={20} maxWidth={180} /> <span className={'cp'}><HeadingSkeleton block={false} height={20} maxWidth={180} /> </span> </h2>
            <Row>
                {
                    [1,2,3,4,5,6].map((item,index)=>{
                        return(
                            <Col className={'mb-4'} sm={12} md={6} xl={6} xxl={4} key={index}>
                                <div className={'gratitude-card'}>
                                    <h3> <HeadingSkeleton block={true} height={15} maxWidth={300} /></h3>
                                    <p> <HeadingSkeleton block={true} height={12} maxWidth={200} /></p>
                                    <div className={'options'}>
                                        <div className={'date'}>
                                            <span> <HeadingSkeleton block={false} height={10} maxWidth={'50px'} /></span>
                                        </div>
                                        <div className={'dots cp'}>

                                        </div>
                                    </div>
                                </div>
                            </Col>
                        )
                    })
                }
            </Row>
        </div>
    )
}